export default {
  'consolidatedReportStock.form.reportType.analytical': 'Analytical',
  'consolidatedReportStock.form.reportType.synthetic': 'Synthetic',

  'consolidatedReportStock.form.checkbox.parts': 'Parts',
  'consolidatedReportStock.form.checkbox.consumable': 'Consumables',
  'consolidatedReportStock.form.checkbox.hideInventoryMovementAndStockCorrection':
    'Hide Inventory Movement/Stock Correction?',
  'consolidatedReportStock.form.checkbox.hideInactiveProductsInTheRegister':
    'Hide Inactive Products In The Register',
  'consolidatedReportStock.form.checkbox.displayNonMovingParts':
    'Display Non Moving Parts?',

  'consolidatedReportStock.form.filterBy': 'Filter By',
  'consolidatedReportStock.form.filterBy.manufacturingCode':
    'Manufacturing Code',
  'consolidatedReportStock.form.filterBy.internalCode': 'Internal Code',
  'consolidatedReportStock.form.filterBy.barCode': 'Bar Code',
  'consolidatedReportStock.form.filterBy.description': 'Description',
  'consolidatedReportStock.form.filterBy.manufacturer': 'Manufacturer',
  'consolidatedReportStock.form.filterBy.group': 'Group',
  'consolidatedReportStock.form.filterBy.subGroup': 'Supgroup',

  'consolidatedReportStock.form.filterByFrom': 'From:',
  'consolidatedReportStock.form.filterByTo': 'To:',
  'consolidatedReportStock.form.group': 'Group',
  'consolidatedReportStock.form.subGroup': 'SubGroup',
};
